import i18next from 'i18next';
import ar from './navigation-i18n/ar';
import en from './navigation-i18n/en';
import tr from './navigation-i18n/tr';
import authKeyCloak from '../auth/authKeycloak';

i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('tr', 'navigation', tr);
i18next.addResourceBundle('ar', 'navigation', ar);

function NavigationConfig(role) {
  const responseRole = authKeyCloak[role];
  return responseRole;
}
export default NavigationConfig;
